module.exports = "<div class=\"disclaimer-bar\" ng-show=\"disclaimerBarCtrl.isDisclaimerVisible\">\n\n    <div class=\"text-m\" translate=\"cw.disclaimer.vpn\"></div>\n    <a class=\"icon icon-close icon-xxxs crs-pointer\" ng-click=\"disclaimerBarCtrl.closeDisclaimer()\"></a>\n\n</div>"


//////////////////
// WEBPACK FOOTER
// ./scripts/directives/dashboard/disclaimer-bar/disclaimer-bar.html
// module id = 5R2H
// module chunks = 0